module.exports = __webpack_public_path__ + "img/burger.31c0ebf6.svg";